import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { GlobalService } from '../services/global.service';
import { map } from 'rxjs/operators';
import { GlobalStoreService } from '../services/global-store.service';
import { LOCAL_STORAGE_KEY } from '../../shared/models/constants';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private globalStore: GlobalStoreService,
    private globalService: GlobalService) { }
    // retrieveSIDData()
    // {
    //     const data = localStorage.getItem('getSID');
    //     if (data === null){
    //       this.globalService.getSID();
    //       localStorage.setItem('getSID', 'true');
    //     }
    // }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {
    return this.globalService.isAuthorized().pipe(
      map(obj => {
        if (obj) {
          this.globalStore.profile = obj.profile;

          if (obj.clientMaster) {
            localStorage.setItem(LOCAL_STORAGE_KEY.CLIENT_MASTER, JSON.stringify(obj.clientMaster));
          } else {
            try {
              obj.clientMaster = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY.CLIENT_MASTER));
            } catch {
              obj.clientMaster = null;
            }
          }
          // this.retrieveSIDData();
          if (obj.sidclientMaster) {
            localStorage.setItem(LOCAL_STORAGE_KEY.SID_CLIENT_MASTER, JSON.stringify(obj.sidclientMaster));
          } else {
            try {
              obj.sidclientMaster = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY.SID_CLIENT_MASTER));
            } catch {
              obj.sidclientMaster = null;
            }
          }
          // this.retrieveSIDData();
          this.globalStore.clientMaster = obj.clientMaster;
          this.globalStore.sidclientMaster = obj.sidclientMaster;
          return true;
        } else {
          this.router.navigate(['/unauthorized']);
          return false;
        }
      })
    );
  }
}
